module.exports = __webpack_public_path__ + "static/media/google-badge.ba69aeae.png";